export default "__VITE_ASSET__LuD3Tm8F__"